// JUST FIREBASE LOGIC, HANDLES HTTP/FIREBASE REQUESTS
// IMPORTANT	--	NO MERGE WITH REDUX LOGIC --

import { collection, query, where, getDocs, Timestamp, doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { convertTimestampsToUnix } from '../../utils/dateUtils';

export const fetchViolationsFromFirestore = async (venueID, period) => {
  const { start, end } = period;

  //validate that the venueID is provided
  if (!venueID) {
    console.error('No venue ID provided for fetching violations');
    throw new Error('Venue ID is required');
  }

  // validate that the period is provided
  if (!period || !period.start || !period.end) {
    console.error('Invalid period provided:', period);
    throw new Error('Valid period with start and end dates is required');
  }

  try {
    // Convert ISO dates to Firestore Timestamp
    const startTimestamp = Timestamp.fromDate(new Date(start));
    const endTimestamp = Timestamp.fromDate(new Date(end));

    // Validate that the timestamps are valid
    if (!startTimestamp || !endTimestamp) {
      throw new Error('Invalid date format provided');
    }

    const violationsRef = collection(db, 'violations');

    const q = query(
      violationsRef,
      where('vid', '==', venueID),
      where('timestamp', '>=', startTimestamp),
      where('timestamp', '<', endTimestamp)
    );

    const querySnapshot = await getDocs(q);
    const violationsData = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...convertTimestampsToUnix(doc.data())
    }));

    return violationsData;
  } catch (error) {
    throw new Error(`Error fetching violations: ${error.message}`);
  }
};

export const updateViolationFromFirestore = async (updatedFields, violationId) => {
  // Destructure the updated fields and the violation ID

  if (!violationId) {
    throw new Error('violation Id is required to update a violation');
  }

  try {
    const violationRef = doc(db, 'violations', violationId);

    // Validate that the violation exists
    const existingViolationSnap = await getDoc(violationRef);
    if (!existingViolationSnap.exists()) {
      throw new Error('Violation not found in Firestore');
    }

    // Update the violation with the new fields
    await updateDoc(violationRef, updatedFields);

    // Get the updated violation
    const updatedViolationtSnap = await getDoc(violationRef);
    const updatedViolation = { id: updatedViolationtSnap.id, ...convertTimestampsToUnix(updatedViolationtSnap.data()) };

    return updatedViolation; // returns the updated violation
  } catch (error) {
    console.error('Failed to update violation:', error);
    throw new Error('Error updating violation');
  }
};
